import { render, staticRenderFns } from "./OverViewPayment.vue?vue&type=template&id=66997e65&"
import script from "./OverViewPayment.vue?vue&type=script&lang=js&"
export * from "./OverViewPayment.vue?vue&type=script&lang=js&"
import style0 from "./OverViewPayment.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports